<button
  class="button"
  [attr.data-testid]="testId()"
  [ngClass]="[
    'button--' + mode(),
    'button--' + size(),
    'button--' + (form() || (!hasContent() && icon() ? 'circle' : 'square')),
    adaptive() ? 'button--adaptive-' + adaptive() : '',
    filled() ? 'button--filled' : '',
    disabled() ? 'button--disabled' : '',
    utility() === 'dropdown' ? 'button--dropdown' : '',
    !hasContent() && icon() ? 'button--only-icon' : '',
    buttonClass() ?? '',
  ]"
  [disabled]="disabled()"
  [tabIndex]="tabindex()"
  (click)="onClick($event)"
  #buttonElement
>
  @if (href()) {
    <a
      [href]="href()"
      target="_blank"
      [class.cursor-default]="disabled()"
      (click)="onLinkClick($event)"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </a>
  } @else {
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  }
</button>

<ng-template #buttonContent>
  @if (icon()) {
    <svg
      class="button__icon svg-icon"
      [ngClass]="[
        'button__icon--' + icon(),
        'svg-icon--' + icon(),
        iconColor() === 'red' ? 'fill-red-500' : '',
        iconColor() === 'green' ? 'fill-green-500' : '',
        iconColor() === 'violet' ? 'fill-violet-500' : '',
      ]"
      [style.width.px]="iconSize()"
      [style.height.px]="iconSize()"
    >
      <use [attr.xlink:href]="'#' + icon()"></use>
    </svg>
  }

  <div class="button__content" #contentElement>
    <ng-content></ng-content>
  </div>

  @if (numberBadge()) {
    <shared-ui-badge class="ml-[8px]" [text]="numberBadge()"></shared-ui-badge>
  }

  @if (utility() === 'dropdown') {
    <svg class="button__arrow svg-icon">
      <use xlink:href="#16px_arrow-down"></use>
    </svg>
  }
</ng-template>
